import React from 'react';
import './AnimatedCow.css';

const AnimatedCow = ({
    animation = 'moving',
    size = 'medium',
    className = '',
    style = {}
}) => {
    const sizeClass = `cow-${size}`;
    const animationClass = `cow-${animation}`;

    return (
        <div
            className={`animated-cow ${sizeClass} ${animationClass} ${className}`}
            style={style}
        >
            <video 
                src="/img/1.mp4" 
                className="cow-video" 
                autoPlay 
                loop 
                muted 
                playsInline
                disablePictureInPicture
            />
        </div>
    );
};

export default AnimatedCow;
